import { CellProps } from 'react-table'
import { PlainHeader, StackedCell, StatusDot, TableColumn } from '../../../../../../components'
import { CategoriaNotificacaoLabels } from '../../../../../../../_metronic/helpers'
import { NotificacaoAdminList } from '../../../core/_models'
import { NotificacaoEnviadaActionsCell } from './NotificacaoEnviadaActionsCell'

// Ordem fixa por id decrescente (mais recentes primeiro, ver QueryRequestProvider): cabeçalhos
// não ordenáveis, como antes.
export const NotificacoesEnviadasColumns: ReadonlyArray<TableColumn<NotificacaoAdminList>> = [
  {
    Header: () => <PlainHeader>Destinatário</PlainHeader>,
    id: 'destinatario',
    cellWidth: '220px',
    Cell: ({ row }: CellProps<NotificacaoAdminList>) => (
      <StackedCell primary={row.original.pessoa?.nomeSocial || row.original.pessoa?.nome} />
    ),
  },
  // Título com a categoria como apoio.
  {
    Header: () => <PlainHeader>Título</PlainHeader>,
    id: 'titulo',
    Cell: ({ row }: CellProps<NotificacaoAdminList>) => (
      <StackedCell
        primary={row.original.titulo}
        secondary={
          row.original.categoria ? CategoriaNotificacaoLabels[row.original.categoria] : undefined
        }
      />
    ),
  },
  // Push e leitura em texto + tom: a cor só reforça.
  {
    Header: () => <PlainHeader>Push</PlainHeader>,
    id: 'enviarPush',
    cellWidth: '150px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<NotificacaoAdminList>) =>
      row.original.enviarPush ? (
        <StatusDot label='Push enviado' tone='success' />
      ) : (
        <StatusDot label='Sem push' tone='neutral' />
      ),
  },
  {
    Header: () => <PlainHeader>Status</PlainHeader>,
    id: 'lida',
    cellWidth: '130px',
    Cell: ({ row }: CellProps<NotificacaoAdminList>) =>
      row.original.lida ? (
        <StatusDot label='Lida' tone='success' />
      ) : (
        <StatusDot label='Não lida' tone='neutral' />
      ),
  },
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<NotificacaoAdminList>) => (
      <NotificacaoEnviadaActionsCell notificacao={row.original} />
    ),
  },
]
